<template>
  <esg-base-dashboard>
    <b-row>
      <!-- 제품군별 온실가스 배출량 비율 -->
      <b-col lg="6">
        <sortable-firmwide-emission-by-product-family/>
      </b-col>
      <!-- /제품군별 온실가스 배출량 비율 -->

      <!-- 공정별 온실가스 배출량 비율 -->
      <b-col lg="6">
        <selectable-year-firmwide-emission-by-product-family/>
      </b-col>
      <!-- /공정별 온실가스 배출량 비율 -->
    </b-row>

    <b-row>
      <!-- LCA 진척 상황 -->
      <b-col lg="6">
        <lca-progress/>
      </b-col>
      <!-- /LCA 진척 상황 -->
    </b-row>
  </esg-base-dashboard>
</template>
<script>
import EsgBaseDashboard from "@/components/esg/base/EsgBaseDashboard.vue";
import LcaProgress from "../../dashboardCards/LcaProgress.vue";
import SortableFirmwideEmissionByProductFamily from "../../dashboardCards/SortableFirmwideEmissionByProductFamily.vue";
import SelectableYearFirmwideEmissionByProductFamily from "../../dashboardCards/SelectableYearFirmwideEmissionByProductFamily.vue";

export default {
  components: {
    EsgBaseDashboard,
    SelectableYearFirmwideEmissionByProductFamily,
    SortableFirmwideEmissionByProductFamily,
    LcaProgress,
  },
}
</script>